import React, { useEffect, useState } from "react";
import { IconPlus, IconX, IconBook2 } from "@tabler/icons-react";
import { useCRM } from "../CRMContext";
import { getSavedViews, createSavedView, deleteSavedView } from "../services/savedViews.service";
import CRMGuideModal from "./CRMGuideModal";

const SavedViews = () => {
  const { state, setSavedViews, setActiveView, setFilters, clearFilters, refreshBoard, showToast } = useCRM();
  const { savedViews, activeViewId, activePipelineId, filters } = state;

  const [showSaveInput, setShowSaveInput] = useState(false);
  const [viewName, setViewName] = useState("");
  const [showGuide, setShowGuide] = useState(false);

  useEffect(() => {
    if (!activePipelineId) return;
    const load = async () => {
      try {
        const data = await getSavedViews(activePipelineId);
        setSavedViews(data.results || data || []);
      } catch {
        // silent
      }
    };
    load();
  }, [activePipelineId, setSavedViews]);

  const handleSelectView = (view) => {
    if (view === null) {
      setActiveView(null);
      clearFilters();
      refreshBoard({});
      return;
    }
    setActiveView(view.id);
    const viewFilters = view.filters || {};
    setFilters(viewFilters);
    refreshBoard(viewFilters);
  };

  const handleSaveView = async () => {
    if (!viewName.trim()) return;
    try {
      const newView = await createSavedView({
        name: viewName.trim(),
        pipeline: activePipelineId,
        filters,
      });
      setSavedViews([...savedViews, newView]);
      setActiveView(newView.id);
      setViewName("");
      setShowSaveInput(false);
      showToast("Visualização salva!");
    } catch {
      showToast("Erro ao salvar visualização.", "error");
    }
  };

  const handleDeleteView = async (e, viewId) => {
    e.stopPropagation();
    try {
      await deleteSavedView(viewId);
      setSavedViews(savedViews.filter((v) => v.id !== viewId));
      if (activeViewId === viewId) {
        setActiveView(null);
        clearFilters();
        refreshBoard();
      }
      showToast("Visualização removida!");
    } catch {
      showToast("Erro ao remover.", "error");
    }
  };

  return (
    <div className="crm-views">
      <button
        className={`crm-views__tab ${activeViewId === null ? "crm-views__tab--active" : ""}`}
        onClick={() => handleSelectView(null)}
      >
        Todos os contatos
      </button>

      {savedViews.map((view) => (
        <button
          key={view.id}
          className={`crm-views__tab ${activeViewId === view.id ? "crm-views__tab--active" : ""}`}
          onClick={() => handleSelectView(view)}
        >
          {view.name}
          <span
            style={{ marginLeft: 6, opacity: 0.5, cursor: "pointer" }}
            onClick={(e) => handleDeleteView(e, view.id)}
            title="Remover"
          >
            <IconX size={12} />
          </span>
        </button>
      ))}

      {showSaveInput ? (
        <div style={{ display: "flex", alignItems: "center", gap: 4, padding: "0 8px" }}>
          <input
            className="crm-input"
            style={{ width: 140, padding: "4px 8px", fontSize: 13 }}
            placeholder="Nome da view"
            value={viewName}
            onChange={(e) => setViewName(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSaveView()}
            autoFocus
          />
          <button className="crm-btn crm-btn--sm crm-btn--primary" onClick={handleSaveView}>Salvar</button>
          <button className="crm-btn crm-btn--sm" onClick={() => setShowSaveInput(false)}>
            <IconX size={12} />
          </button>
        </div>
      ) : (
        <button className="crm-views__add" onClick={() => setShowSaveInput(true)}>
          <IconPlus size={14} /> Salvar View
        </button>
      )}

      <button className="crm-views__add" onClick={() => setShowGuide(true)} style={{ marginLeft: "auto" }}>
        <IconBook2 size={14} /> Guia Prático
      </button>

      <CRMGuideModal show={showGuide} onHide={() => setShowGuide(false)} />
    </div>
  );
};

export default SavedViews;
